import ApiService from "../../utils/fetch";
const userRolesUrl = `${process.env.REACT_APP_BASE_URL}user-access/`;

export const fetchAllReports = async () => {
    const url = `${userRolesUrl}getAllReports`;
    const response = await ApiService.get(url);
    return response.data;
}

export const revokeUserAccess = async (payload) => {
    const url = `${userRolesUrl}revokeUserAccess`;
    const response = await ApiService.delete(url, payload);
    return response.data;
};